<div class="card container">
  <div class="box">
    <div class="info">
      <h3>Agenda do dia</h3>
      <span>{{ diaDeHoje }}</span>
    </div>
    <div class="filtro">
      <button class="btn btn-outline-secondary">
        <i class="icone fa-solid fa-filter"></i>  
        Filtros
      </button>
    </div>
  </div>
  <div class="botoes">
    <button class="botao-rosa" (click)="filtrarHoje()">Hoje</button>
    <button class="botao-rosa" (click)="filtrarAmanha()">Amanhã</button>
    <button class="botao-rosa" (click)="filtrarFinalDeSemana()">Final de semana</button>
    <button class="botao-rosa" (click)="filtrarMes()">Mês</button>
  </div>
  <div class="lista">
    <div>
      <div *ngFor="let slot of timeSlots" class="time-slot">
        <span class="time">{{ slot }}</span>
        <hr>
        <div *ngFor="let evento of getEventosDoSlot(slot)" class="card-evento">
          <div class="box-informacoes">
            <div *ngIf="evento.nomePublicacao" class="time-range">
              <i class="fa-regular fa-clock"></i>
              {{ evento.dscHoraInicioEvento }} - {{ evento.dscHoraFimEvento }}
            </div>
            <div *ngIf="!evento.nomePublicacao" class="time-range">
              <i class="fa-regular fa-clock"></i>
              Horário não informado.
            </div>
            <div *ngIf="evento.nomePublicacao" class="title"> 
              <i class="fa-solid fa-tag"></i>
              {{ evento.nomePublicacao }}
            </div>
            <div *ngIf="!evento.dscEnderecoEvento" class="title"> 
              <i class="fa-solid fa-tag"></i>
              Nome do evento não informado.
            </div>
            <div *ngIf="evento.dscEnderecoEvento"  class="location">
              <i class="icone fa-solid fa-location-dot"></i>
              {{ evento.dscEnderecoEvento }}
            </div>
            <div *ngIf="!evento.dscEnderecoEvento" class="location">
              <i class="icone fa-solid fa-location-dot"></i>
              Endereço não informado.
            </div>
          </div>
          <button class="botao-rotas">
            <i class="icone fa-solid fa-route"></i>
            Obter rotas
          </button>
        </div>
      </div>
    </div>
  </div>
</div>